<template>
    <div class="i-list">
        <div v-if="paginate>0">
            <btn i='chevron-left' @press="prevPage()" />
            {{page+1}} / {{ pages }}
            <btn i='chevron-right' @press="nextPage()" />
        </div>
        <table border="1">
            <thead>
                <tr>
                    <td v-for="field in fields">{{field.label}}</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in paginate_data(data)" :key="item._id?item._id:index" @click="selectItem(item._id?data.find(i=>i._id==item._id):data[index], index)">
                    <td v-for="field in fields" :key="(item._id?item._id:index)+'-'+field.name">
                        <i-multi-view :config="field" :value="item[field.name]" :index="index" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { DateTime } from "luxon";
//
import iMultiView from "./i-multi-view.vue"
export default {
    name: 'i-list',
    components: {
        iMultiView
    },
    watch: {
        data() {
            this.page = 0;
        }
    },
    mounted() {
        let self = this;
        //console.log(this)
        _i.bus.$on('list-update', () => {
            self.$forceUpdate();
        })
    },
    methods: {
        paginate_data(data) {
            let { paginate, page, fields } = this;
            let filtered = paginate > 0 ? data.slice(page * paginate, page * paginate + paginate) : data;
            return filtered.map((item, key) => {
                //console.log(key, item)
                //console.log(_i.flatify(item))
                return _i.flatify(item);

            });
        },
        prevPage() {
            if (this.page == 0) return;
            this.page--;
        },
        nextPage() {
            if (this.page >= this.pages - 1) return;
            this.page++;
        },
        selectItem(item, idx) {
            //this.action(item);
            this.$emit('input', item, idx)
        },
        //flatify:_i.flatify,
        /*field_format(item, index) {
            let { fields } = this;

            let fItem = _i.flatify(item)[field.name];
            let self = this;
            return fields.map((field) => {
                if (field.type === 'index') {
                    if (this.paginate > 0) {
                        return wrap(this.page * this.paginate + index + 1);
                    } else return wrap(index + 1);
                }
                let value = fItem[field.name];
                //if() return ``;
            }).join("");

        }*/
    },
    props: {
        paginate: { type: Number, default: 0 },
        fields: {
            type: Array,
            default () {
                return [{
                    label: 'ID',
                    name: '_id'
                }, {
                    label: 'Название',
                    name: 'title'
                }, {
                    label: 'Краткое Содержание',
                    name: 'short'
                }]
            }
        },
        data: {
            type: Array,
            default () {
                return [{
                    "_id": "1",
                    "title": "Антон Бугаенко о внешней политике Казахстана",
                    "text": "",
                    "preview": "QQ.png",
                    "date": "",
                    "short": "Казахстан занял 70-е из 163 мест в рейтинге миролюбивых стран.\n\nИ это вовсе не удивительно, если принять во внимание внешнюю политику Главы государства, направленную на выстраивание добрососедских отношений с нашими дальними и ближними стратегическими партнерами.",
                    "source": "",
                    "authors": "",
                    "tags": ""
                }]
            }
        }
    },
    data() {
        return {
            page: 0
        }
    },
    computed: {
        pages() {
            return Math.ceil(this.data.length / this.paginate);
        }
    }
}
</script>
<style lang="css" scoped>
table {
    border-collapse: collapse;
    border-color: lightgrey;
    border-radius: 4px;
    overflow: hidden;
    /*border: 1px solid lightgrey;*/
    box-shadow: 0px 0px 1px black;
}

table td {
    padding: 4px 8px;
    border-right: none;
}

thead td {
    background: whitesmoke;
    border: 1px solid lightgrey;
    font-weight: bold;
}

tbody tr:hover {
    background: whitesmoke;
    cursor: pointer;
}
</style>
<style>
.cell-boolean-true,
.cell-boolean-false {
    text-align: center;
}

.cell-boolean-true {
    background: green;
}

.cell-boolean-false {
    background: red;
}

.cell-string {
    padding: 4px 8px;
}
</style>